import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bankAccountFormat',
})
export class BankAccountFormatPipe implements PipeTransform {
  transform(value?: string): string | undefined {
    if (!value) return value;

    const cleaned = value.replace(/\s+/g, '');

    // NRB (26 cyfr)
    if (/^\d{26}$/.test(cleaned)) {
      return (
        cleaned.slice(0, 2) +
        ' ' +
        cleaned
          .slice(2)
          .match(/.{1,4}/g)
          ?.join(' ')
      );
    }

    // IBAN
    if (/^[A-Z]{2}\d{2}[A-Z0-9]+$/i.test(cleaned)) {
      return cleaned.match(/.{1,4}/g)?.join(' ');
    }

    return value;
  }
}
